<template>
  <section class="px-0 md:px-6 py-6">
    <slot />
  </section>
</template>
